"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var colors_scss_1 = __importDefault(require("./colors.scss"));
exports.default = {
    primary: {
        light: colors_scss_1.default.primary_light,
        main: colors_scss_1.default.primary_main,
        dark: colors_scss_1.default.primary_dark,
    },
    secondary: {
        light: colors_scss_1.default.secondary_light,
        main: colors_scss_1.default.secondary_main,
        dark: colors_scss_1.default.secondary_dark,
    },
    grey: {
        500: colors_scss_1.default.grey_500,
        600: colors_scss_1.default.grey_600,
        700: colors_scss_1.default.grey_700,
        800: colors_scss_1.default.grey_800,
        900: colors_scss_1.default.grey_900,
    },
    error: {
        light: colors_scss_1.default.error_light,
        main: colors_scss_1.default.error_main,
        dark: colors_scss_1.default.error_dark,
    },
    success: {
        light: colors_scss_1.default.success_light,
        main: colors_scss_1.default.success_main,
        dark: colors_scss_1.default.success_dark,
    },
    warning: {
        light: colors_scss_1.default.warning_light,
        main: colors_scss_1.default.warning_main,
        dark: colors_scss_1.default.warning_dark,
    },
    info: {
        light: colors_scss_1.default.info_light,
        main: colors_scss_1.default.info_main,
        dark: colors_scss_1.default.info_dark,
    },
    background: {
        default: colors_scss_1.default.background,
    },
    text: {
        primary: colors_scss_1.default.text_primary,
        secondary: colors_scss_1.default.text_secondary,
    },
};
